
namespace GeniuzPOS.PosShift {
    import fld = PsEndDayCashierRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PsEndDayCashierGrid extends Serenity.EntityGrid<PsEndDayCashierRow, any> {
        protected getColumnsKey() { return PsEndDayCashierColumns.columnsKey; }
        protected getDialogType() { return PsEndDayCashierDialog; }
        protected getIdProperty() { return PsEndDayCashierRow.idProperty; }
        protected getInsertPermission() { return PsEndDayCashierRow.insertPermission; }
        protected getLocalTextPrefix() { return PsEndDayCashierRow.localTextPrefix; }
        protected getService() { return PsEndDayCashierService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsEndDayCashierService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.CreateDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-7));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            return filters;
        }
    }
}